import React from 'react';
import { SvgProps } from './icon.types';

function Line({ title, fillColor = '#ecedf0', ...props }: SvgProps) {
  return (
    <svg height="5.8" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <line stroke={fillColor} strokeWidth="12" x1="0" x2="100%" y1="10" y2="10" />
    </svg>
  );
}

export { Line };
